import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  user_id: string;
  tipo_perfil: 'comprador' | 'vendedor';
  nombre_completo: string | null;
  pueblo: string | null;
  telefono: string | null;
  tipo_identificacion: string | null;
  numero_identificacion: string | null;
  url_identificacion: string | null;
  reputacion: number;
  created_at: string;
};